import { put, takeLatest, call } from 'redux-saga/effects';
import { httpCreators, HttpResponse } from '@ppvrbh/merchant-frontend-core';
import { DEVICE_STATE_KEY } from './device-reducer';
import { DeviceService } from './device-service';
import {DEVICE_REQUEST_ID_LIST, DEVICE_TRANSLATION_KEY} from './device-constant';
import { deviceCreators } from './device-action';
import { generalSagas } from '../../../../redux/general/general-saga';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { noop } from 'lodash';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';

function* callDeviceListTnc() {
  yield put(httpCreators.request({
    id: DEVICE_REQUEST_ID_LIST.POST_DEVICE_LIST,
    sagaHandler: postDeviceListHandler as any,
    service: DeviceService.postDeviceList
  }));
  yield call(generalSagas.callTnc);
}

function* postDeviceListHandler(resp: HttpResponse) {
  if (resp.success) {
    yield put(deviceCreators.setDeviceState(DEVICE_STATE_KEY.DEVICE_LIST, resp.data.instantLogin as []));
    yield put(deviceCreators.setDeviceState(DEVICE_STATE_KEY.MAX_DEVICE_LOGIN, resp.data.maxDeviceLogin));
  } else {
    yield put(deviceCreators.setDeviceState(DEVICE_STATE_KEY.DEVICE_LIST, undefined));
  }
}

function* postForceLogoutHandler(resp: HttpResponse, callbackParams: {
  resetReload: () => void, deviceDisplay: string }) {
  if (resp.success || (resp.statusCode === 1899 && resp.data?.translationKey === DEVICE_TRANSLATION_KEY.DEVICE_LOGOUT_IS_INVALID)) {
    yield call(callbackParams.resetReload);
    yield put(deviceCreators.setDeviceState(DEVICE_STATE_KEY.ALERT_SUCCESS, {
      isVisible: true,
      translationValues: {
        deviceDisplay: callbackParams.deviceDisplay,
      }
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

export const deviceSagas = {
  callDeviceListTnc,
  postDeviceListHandler,
  postForceLogoutHandler,
  watchers: [
    takeLatest(DEVICE_REQUEST_ID_LIST.CALL_DEVICE_LIST_TNC, callDeviceListTnc),
  ]
};


